import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

/** The path the app was first loaded at, read once when it starts. */
const FIRST_PATH = window.location.pathname;

/**
 * The home page is a static page in public/landing. On Tadpole's own
 * domains, vercel.json serves it at "/" before the app loads. The app only
 * reaches this route when it links to "/" itself, or when the server sent
 * the app for "/": a login coming back with ?code=&state=, or a host
 * vercel.json doesn't list (localhost). A login that lands here finishes
 * first. Then the page loads the home page, keeping any #section: from "/"
 * when the server sends it there, or from its own file when the server sent
 * the app for "/".
 */
export default function LandingPage() {
  const { isLoading } = useAuth0();

  useEffect(() => {
    if (isLoading) return;
    const page = FIRST_PATH === "/" ? "/landing/index.html" : "/";
    window.location.replace(page + window.location.hash);
  }, [isLoading]);

  return null;
}
